module.exports = new __parcel__URL__("figurative.82f98a82.png").toString();